import React, { createContext, useContext, useEffect, useState } from 'react';

interface FormContextType {
  ecomFormData: Record<string, any>;
  setEcomFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  projectFormData: Record<string, any>;
  setProjectFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  resetProjectFormData: () => void;
  // Add Project calculation values
  runningTotal: string;
  setRunningTotal: (value: string) => void;
  substructureTotal: string;
  setSubstructureTotal: (value: string) => void;
  superstructureTotal: string;
  setSuperstructureTotal: (value: string) => void;
  superstructureContTotal: string;
  setSuperstructureContTotal: (value: string) => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [ecomFormData, setEcomFormData] = useState<Record<string, any>>({});
  const [projectFormData, setProjectFormData] = useState<Record<string, any>>({});
  const [runningTotal, setRunningTotal] = useState('');
  const [substructureTotal, setSubstructureTotal] = useState('');
  const [superstructureTotal, setSuperstructureTotal] = useState('');
  const [superstructureContTotal, setSuperstructureContTotal] = useState('');

  const resetProjectFormData = () => {
    setProjectFormData({});
  };

  useEffect(() => {
    console.log('projectFormData have been updated:', projectFormData);
  }, [projectFormData]);

  return (
    <FormContext.Provider 
      value={{ 
        ecomFormData, 
        setEcomFormData, 
        projectFormData, 
        setProjectFormData, 
        resetProjectFormData,
        runningTotal,
        setRunningTotal,
        substructureTotal,
        setSubstructureTotal,
        superstructureTotal,
        setSuperstructureTotal,
        superstructureContTotal,
        setSuperstructureContTotal,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useFormContext must be used within a FormProvider');
  }
  return context;
};
